import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { DiversityCheckModal } from './diversity-check.modal';
import { DiversityService } from '../shared/diversity.service';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, PipesModule],
    declarations: [DiversityCheckModal],
    providers: [DiversityService]
})
export class DiversityCheckModule {}
